export enum ItemType {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE'
}
